import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../../utils/alert'
import { api } from '../../../api'
import { localConfig } from '../../../../Configs/localConfig'

interface Params {
  cod_consultor: number
  tipo_acao: 'add' | 'remover'
  assistente_tecnicos_add?: number[]
  assistente_tecnicos_remover?: number[]
  refetchGerenciar: Function
  limpar: Function
}

export const usePostGerenciarEquipeConsultor = (): {
  carregando_salvar_consultor: boolean
  mutate_salvar_consultor: (params: Params) => void
  isSuccess_salvar_consultor: boolean
} => {
  const mutation: UseMutationResult<Response, Error, Params> = useMutation(
    async (params: Params) => {
      const { tipo_acao, assistente_tecnicos_add, assistente_tecnicos_remover, cod_consultor, refetchGerenciar, limpar } =
        params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      function tipoAcao() {
        return tipo_acao === 'add'
          ? { assistente_tecnico: assistente_tecnicos_add }
          : { assistente_tecnico_remover: assistente_tecnicos_remover }
      }

      return api
        .post(`gerenciar-equipe-consultor?codConta=${localConfig()?.conta}`, {
          cod_consultor: cod_consultor,
          ...tipoAcao(),
        })
        .then((response: any) => {
          successAlert(
            tipo_acao === 'add' ? 'Adicionado com sucesso!' : 'Removido com sucesso!',
            5000,
            'loading'
          )
          limpar()
          refetchGerenciar()
          return response
        })
        .catch((error: any) => {
          errorAlert(
            tipo_acao === 'add' ? 'Falha ao adicionar assistente' : 'Falha ao remover assistente',
            5000,
            'loading'
          )
          errorAlert(error?.response?.data?.error ?? 'Falha salvar alteração!')
          throw error
        })
    }
  )

  return {
    carregando_salvar_consultor: mutation.isLoading,
    mutate_salvar_consultor: mutation.mutate,
    isSuccess_salvar_consultor: mutation.isSuccess,
  }
}
